import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ITopology } from "../../constants/types";
import { RootState } from "../setupStore";

export type ITaskPanelState = {
  isOpen: boolean;
  selectedTopology?: ITopology;
  selectedMachineName?: string;
};

export const initialTaskPanelState: ITaskPanelState = {
  isOpen: false,
  selectedMachineName: undefined,
  selectedTopology: undefined,
};

const taskPanelSlice = createSlice({
  name: "taskPanel",
  initialState: initialTaskPanelState,
  reducers: {
    taskPanelClosed(state) {
      state.isOpen = false;
    },
    topologyMachineSelected(state, action: PayloadAction<{ topology: ITopology; machineName: string }>) {
      const { topology, machineName } = action.payload;
      state.selectedTopology = topology;
      state.selectedMachineName = machineName;

      if (state.isOpen === false) {
        state.isOpen = true;
      }
    },
  },
});

export const { taskPanelClosed, topologyMachineSelected } = taskPanelSlice.actions;

export default taskPanelSlice.reducer;

// Simple selector for selecting currently selected topology
const selectSelectedTopology = (state: RootState) => state.taskPanel.selectedTopology;

// Simple selector for selecting currently specified machine name.
const selectSelectedMachineName = (state: RootState) => state.taskPanel.selectedMachineName;

/**
 * Selector that returns the {@link IMachineExt} instance for the currently selected machine, which
 * contains the machine's password, used for the connect button in the Task Panel.
 */
export const selectMachineForConnectButton = createSelector(
  [selectSelectedTopology, selectSelectedMachineName],
  (topology: ITopology | undefined, selectedMachineName: string | undefined) => {
    if (!topology || !selectedMachineName) return;

    return topology.MachinesExt.find((m) => m.Name === selectedMachineName);
  },
);
